module.exports = __webpack_public_path__ + "static/media/puppeteer.19e75847.png";